$(function(){
    var interval;

    function startSlideshow(element){
        var timeout = element.data('timeout');
        var height = element.data('height');
        var positionY;
        var currentPosition;
        var backgroundPos;
        return setInterval(function(){
            currentPosition = parseInt(element.css('background-position-y'));
            positionY = currentPosition + height + 'px';
            element.stop().animate({"opacity": "0.7"}, 200);
            element.animate({
                backgroundPositionY: positionY
            }, 0);
            element.animate({"opacity": "1"}, 200);
        }, timeout);
    }

    $('.sprite-slideshow').hover(function(){
        interval = startSlideshow($(this));
    }, function(){
        clearInterval(interval);
    });
});